/*
 * $Id:: index.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { ReactComponent as InfoIcon } from '../../../assets/images/info_24px.svg';
import { t } from '../../../providers';
import { resetPasswd as resetPasswdSlice, error as resetPasswordError, loading as resetPasswordLoading } from '../authenticationSlice';
import AuthContainer from '../components/AuthContainer';
import RequestResult from '../components/RequestResult';
import { SLICE_NAME } from '../constants';
import ResetPasswordForm from './components';

const ResetPasswordPage = () => {
    const infoIcon = <InfoIcon aria-hidden="true" focusable="false" />;
    const history = useHistory();

    const loading = useSelector(resetPasswordLoading);
    const error = useSelector(resetPasswordError);
    const resetPasswd = useSelector(resetPasswdSlice);
    const dispatch = useDispatch();

    const { token } = useParams();

    useEffect(() => {
        const validateToken = () => {
            if (!token) {
                dispatch({ type: `${SLICE_NAME}/error`, payload: { description: 'password.reset.link.not.valid' } });
            }
            dispatch({ type: `${SLICE_NAME}/validateResetToken`, payload: token });
        };
        validateToken();
    }, [token, dispatch]);

    const setNewPassword = (password) => {
        if (password) {
            dispatch({ type: `${SLICE_NAME}/resetPassword`, payload: { password, token } });
        }
    };

    const requestNewLink = () => {
        dispatch({ type: `${SLICE_NAME}/error`, payload: null });
        history.push('/forgotten-login');
    };

    const navigateToLogin = () => {
        dispatch({ type: `${SLICE_NAME}/auth`, payload: {} });
        history.push('/login');
    };

    let renderBody;
    let title = 'please.reset.your.password';
    if (error && error.description === 'password.reset.link.not.valid') {
        renderBody = <RequestResult action={requestNewLink} message={error.description} button={'request.new.password.link'} />;
        title = 'expired.password.link';
    } else if (!error.description && resetPasswd && resetPasswd.valid) {
        renderBody = <RequestResult action={navigateToLogin} message={'register.new.password.success'} button={'back.to.login'} />;
        title = 'reset.password.complete';
    } else {
        renderBody = <ResetPasswordForm setNewPassword={setNewPassword} error={(error && error.description) || ''} loading={loading} />;
    }

    return (
        <AuthContainer preTitle={infoIcon} title={t(title)}>
            {renderBody}
        </AuthContainer>
    );
};

export default ResetPasswordPage;
